export default class ValidationError extends Error {
  fieldErrors: Record<string, string | string[]>;

  constructor(fieldErrors: Record<string, string | string[]>) {
    super("Form error");
    this.fieldErrors = fieldErrors;
  }
}
